import {Component, Input, OnInit} from "@angular/core";
import {ChangePasswordComponent} from "./components/change-password/change-password.component";
import {LogsReportDialogComponent} from "./components/logs-report-dialog/logs-report-dialog.component";
import {UsageReportDialogComponent} from "./components/usage-report-dialog/usage-report-dialog.component";
import {OrganizationUsageReportDialogComponent} from "./components/organization-usage-report-dialog/organization-usage-report-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {NotifyParentService} from "../../../core/services/notify-parent.service";
import {PaymentControllerService} from "../../../core/api/controllers/payment-controller.service";
import {NotificationService} from "../../../core/services/notification.service";
import {GlobalPreferences} from "../../../core/helpers/global-data";
import {MessageService} from "../../../core/services/message-service";
import {FileUploader} from "ng2-file-upload";
import {DomSanitizer} from "@angular/platform-browser";

import {MediaControllerService} from "../../../core/api/controllers/media-controller.service";
import {AccountControllerService} from "../../../core/api/controllers/account-controller/account-controller.service";
import {Router} from "@angular/router";
import {
  ChangeAccountInformationDialogComponent
} from "./components/change-account-information-dialog/change-account-information-dialog.component";
import {_pt} from "../../../core/services/preview-text/helpers/preview-text.function";
import {ISettingsDTO} from "../../../shared/DTOs/ISettingsDTO";
import {SettingsService} from "../../../core/services/settings.service";
import {AuthService} from "../../../core/services/auth.service";
import {IGetCountsResponse} from "../../../core/api/controllers/account-controller/interfaces/get-counts.response";
import {ESyncType} from "../../../shared/enums/ESyncType";

@Component({
  selector: "app-generic-account-card",
  templateUrl: "./generic-account-card.component.html",
  styleUrls: ["./generic-account-card.component.scss"],
})
export class GenericAccountCardComponent implements OnInit {
  imagePreviewUrl = null;
  imageUploader: FileUploader;
  imageNeedsUpdate = false;
  image = null;
  profilePicture;
  showQuickbooks = false;
  mandatoryEmail = false;

  counts: IGetCountsResponse;

  @Input() settingsData: ISettingsDTO;
  @Input() isLoading = false;
  @Input() paymentData: any;

  constructor(
    public paymentController: PaymentControllerService,
    private settingsService: SettingsService,
    private mediaController: MediaControllerService,
    private parentNotifier: NotifyParentService,
    private notificationService: NotificationService,
    public global: GlobalPreferences,
    private messageService: MessageService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private accountController: AccountControllerService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.initImageUploader();
    this.initFields();
    this.getCounts();
  }

  getCounts(): void {
    this.isLoading = true;
    this.accountController.getLocationCounts(AuthService.getSelectedLocationId()).subscribe({
      next: (counts) => {
        this.counts = counts;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.error("There was an error fetching the counts for athletes and exercises.");
        this.isLoading = false;
      }
    })
  }



  initImageUploader(): void {
    this.imageUploader = new FileUploader({
      queueLimit: 1,
    });
    this.imageUploader.onAfterAddingFile = (file) => {
      this.imageNeedsUpdate = true;
      this.image =
        file.file.type.indexOf("image") >= 0 && file.file.size <= 2000000
          ? file.file
          : null;
      this.imagePreviewUrl = this.sanitizer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(file._file),
      );
    };
  }

  initFields() {
    if (this?.settingsData?.username == "kevin") {
      this.showQuickbooks = true;
    }
    this.profilePicture = this?.settingsData?.profilePictureUrl;
  }

  onSyncStateChanged(newSyncType: ESyncType): void {
    // Handle sync state change if needed
    console.log('Sync type changed to:', newSyncType);
  }

  updateProfilePicture() {
    const data = new FormData();
    data.append("file", this.image.rawFile);
    this.mediaController.mediaUpload(data).subscribe(
      ({ url }) => {
        this.accountController.updateProfilePicture(url).subscribe(() => {
          this.notificationService.success(
            "Profile picture updated successfully.",
          );
          this.profilePicture = this.imagePreviewUrl;
          this.imagePreviewUrl = null;
          this.parentNotifier.sendData("update");
        });
      },
      (error) => this.notificationService.error(error),
    );
  }

  openPasswordModal() {
    this.dialog
      .open(ChangePasswordComponent, {
        width: "600px",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.notificationService.success("Password changed successfully");
        }
      });
  }

  openLogsModal() {
    this.dialog.open(LogsReportDialogComponent, {
      data: {
        organizationId: this.settingsData.organization.id,
      },
      width: "800px",
    });
  }

  openUsageModal() {
    this.dialog.open(UsageReportDialogComponent, {
      data: {
        organizationId: this.settingsData.organization.id,
      },
      width: "800px",
    });
  }

  exportOrganizationUsageReport() {
    this.dialog.open(OrganizationUsageReportDialogComponent, {
      width: "800px",
    });
  }

  connectQuickbooks() {
    this.paymentController.connectQuickbooks().subscribe(
      (response) => {
        this.notificationService.success("Quickbooks connection in progress");
        window.open(response.body, "Quickbooks connect");
      },
      (error) => {
        this.notificationService.error(error);
      },
    );
  }

  openAccountInformationModal(): void {
    this.dialog.open(ChangeAccountInformationDialogComponent, {
      height: "90vh",
      width: "1200px",
      maxWidth: '90vw'
    });
  }

  updateMandatoryEmail() {
    this.accountController.updateUserPreferences(this.mandatoryEmail).subscribe(
      () => {
        this.messageService.sendMandatoryEmail(this.mandatoryEmail);
      },
      (error) => this.notificationService.error(error),
    );
  }

  openSubscriptionPaymentModal() {
    this.router.navigateByUrl("/update-payment-info");
  }

  isSuperAdmin() {
    return this.authService.checkTokenAccess("SuperAdmin");
  }

    protected readonly _pt = _pt;
}
